(function ($) {
  setTimeout(function () {
    $(".leadership-new").addClass("active");
  }, 200);
  $(function () {
    // Add a short delay to ensure all overlays are present before wrapping
    setTimeout(function() {
      var $container = $(".leadership-new .container > .row");
      var $overlays = $container.children('.authors-bio-overlay');
      if ($overlays.length > 6) {
        var $toWrap = $overlays.slice(6);
        var $wrap = $('<div>', {
          'class': 'row author-outer-wrap leadership team-blade-new wow fadeInUp',
          'data-wow-delay': '0.3s'
        });
        $toWrap.appendTo($wrap);
        $container.append($wrap);
      }
      authorsOverlay();
      closeAuthorsOverlay();
    }, 100);

    // Function to add 'open' class on mobile
    function handleMobileOpen() {
      if ($(window).width() <= 1024) {
        var $default1 = $(".authors-bio-overlay");
        $(".authors-bio-overlay").addClass("open");
        $default1.parent().parent().addClass("active");
      } else {
        // Desktop: only open the default one
        var $default = $(".authors-bio-overlay.active");
        if (!$default.length) {
          $default = $(".authors-bio-overlay").first();
        }
        if ($default.length) {
          $(".authors-bio-overlay").removeClass("open");
          $default.addClass("open");
          $default.parent().parent().addClass("active");
          $default.parent().addClass("height");
        }
      }
    }

    // On page load
    setTimeout(function () {
      handleMobileOpen();
    }, 50);

    // On resize
    $(window).on("resize", function () {
      handleMobileOpen();
    });
    $(document).on(
      "click",
      ".author-overlay-popup .leadership-popup-body, .author-overlay-popup .leadership-popup",
      function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
      }
    );
    $(document).on(
      "click",
      ".author-overlay-popup .slider .next,.author-overlay-popup .slider .prev",
      function (e) {
        e.stopImmediatePropagation();
      }
    );
  });
  var overlayIndex = 0;
  function authorsOverlay() {
    $(document).on("click", ".authors-bio-overlay", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $(".authors-bio-overlay").parent().removeClass("clicked");
      $(this).parent().addClass("clicked");
      $(".authors-bio-overlay").removeClass("active");
      $(this).addClass("active");
      $(".author-overlay-popup").empty();
      $(this)
        .find(".overlay-wrap")
        .clone()
        .appendTo(".author-overlay-popup")
        .css("display", "flex");
      $(".author-overlay-popup").addClass("active");
      $(this)
        .parents("section.leadership, section.leadership-new")
        .addClass("leadership-active");
      setTimeout(function () {
        $(".author-overlay-popup")
          .find(".leadership-popup-content")
          .addClass("active");
      }, 10);
      // Set overlayIndex globally based on all overlays, not just siblings
      var $all = $(".leadership-new .authors-bio-overlay");
      overlayIndex = $all.index(this);
    });
    closeAuthorsOverlay();
  }
  function closeAuthorsOverlay() {
    $(document).on("click", ".author-overlay-popup .close-btn", function (e) {
      $(".authors-bio-overlay").parent().removeClass("clicked");
      $(".authors-bio-overlay").removeClass("active");
      $(".author-overlay-popup").removeClass("active");
      $("section.leadership, section.leadership-new").removeClass(
        "leadership-active"
      );
      if ($(".author-overlay-popup .overlay-wrap").hasClass("slider")) {
        $(".author-overlay-popup")
          .find(".leadership-popup-content")
          .removeClass("active");
        $(".author-overlay-popup .overlay-wrap").fadeOut(function () {
          $(this).remove();
        });
      }
    });
    $(document).on("click", function () {
      $(".authors-bio-overlay").parent().removeClass("clicked");
      $(".authors-bio-overlay").removeClass("active");
      $(".author-overlay-popup").removeClass("active");
      if ($(".author-overlay-popup .overlay-wrap").hasClass("slider")) {
        $(".author-overlay-popup .overlay-wrap").fadeOut("400", function () {
          $(this).remove();
        });
      }
    });
  }
  // Use all overlays for popup navigation, regardless of container
  function getAllOverlays() {
    return $(".leadership-new .authors-bio-overlay");
  }
  $(document).on("click", ".author-overlay-popup .slider .next", function () {
    var $all = getAllOverlays();
    overlayIndex += 1;
    if (overlayIndex > $all.length - 1) {
      overlayIndex = 0;
    }
    closeAuthorsOverlay();
    $all.eq(overlayIndex).click();
  });
  $(document).on("click", ".author-overlay-popup .slider .prev", function () {
    var $all = getAllOverlays();
    overlayIndex -= 1;
    if (overlayIndex < 0) {
      overlayIndex = $all.length - 1;
    }
    closeAuthorsOverlay();
    $all.eq(overlayIndex).click();
  });

  // Hover behaviour: add 'open' to hovered .authors-bio-overlay and remove from others
  $(document).on("mouseenter", ".authors-bio-overlay", function (e) {
    // remove 'open' from all, then add to current
    $(".authors-bio-overlay").removeClass("open");
    $(this).addClass("open");
    // maintain the previous active/height classes
    $(this).parent().parent().addClass("active");
    $(this).parent().addClass("height");
  });

  // On mouseleave remove 'open' from the current element and reset classes
  // $(document).on("mouseleave", ".authors-bio-overlay", function (e) {
  //   $(this).removeClass("open");
  //   $(this).parent().parent().removeClass("active");
  //   $(this).parent().removeClass("height");
  // });
})(jQuery);
